import React from 'react';
import { useTranslation } from 'react-i18next';

const BENEFIT_KEYS = ['valueProp1', 'valueProp2', 'valueProp3'];

const ReferralBenefits = () => {
  const { t } = useTranslation();
  return (
    <section aria-label="Key Benefits">
      <h2 className="sr-only">Key Benefits</h2>
      <div className="flex flex-wrap gap-2 justify-center">
        {BENEFIT_KEYS.map((key) => (
          <span
            key={key}
            className="bg-primary/10 text-primary text-xs font-medium px-3 py-1 rounded-full"
          >
            {t(`referral.landing.${key}`)}
          </span>
        ))}
      </div>
    </section>
  );
};

export default ReferralBenefits;
